<template>
  <MenuComponent
    :custom_title="$t('AdditionalFields.AdditionalFields')"
    :filtred_count="count">
    <template #navbar="{ navbarMini }">
      <NavBar
        :active="activeMenuIndex"
        :class="{'mini': navbarMini}"
        :create_router_to="{name: 'addAdditionalField', params: {org: $route.params.org} }"
        :create_text="$t('AdditionalFields.NewAdditionalField')"
        :items="additionalFieldItems"
        :loading="loading.statics"
        :mode="navbarMini"
        :types="menuTypes"
        unload
        @filterItems="choseType">
        <template #list_item_count="{ item }">
          <template v-if="loading.statics">
            <sIcon
              color="#ced8d7"
              size="14"
              spin
              type="loading"/>
          </template>
          <template v-else>
            {{ item.count || 0 }}
          </template>
        </template>
      </NavBar>
    </template>
    <template #filter>
      <SearchInput
        debounce
        :search.sync="statisticsFilters.search"
        width="200px"/>
    </template>
    <template #items>
      <sAlert
        v-if="isTesterOrgs"
        class="mb-4"
        type="warning">
        {{ $t('Common.WarningTitle') }}
        <template slot="desc">
          {{ $t('Common.orgToTesting') }}
        </template>
      </sAlert>
      
      <transition-group>
        <EmptyBlock
          v-if="!loading.items && additionalFieldItems.length === 0"
          key="empty-block"
          :text="statisticsFilters.search ? $t('Tenders.CategoryNotFound') : $t('AdditionalFields.NoAdditionalFields')"/>
        <template v-else>
          <AdditionalFieldCard
            v-for="(item, n) in additionalFieldItems"
            :key="item.id + '' + n"
            :bidding-types="spr.biddingTypes"
            class="mt-5"
            :classifications="spr.classifications"
            :index="n + 1"
            :item="item"
            @delete="deleteField"
            @update="updateField"/>
        </template>
        <div
          v-if="loading.items"
          key="loading-block">
          {{ $t('Common.Loading') }}...
        </div>
      </transition-group>
    </template>
    <template #loader>
      <InfinityUpdater
        ref="infinity_updater"
        :action="infinityLoad"
        :active="canLoad"
        class="mt-3"
        :loading="loading.items"
        :pixels_when_update="150"/>
    </template>
  </MenuComponent>
</template>

<script>
import { debounce } from 'toolkit/utils/util'

import NavBar from 'components/common/blocks/NavBar.vue'
import MenuComponent from 'pages/templates/MenuComponent.vue'
import SearchInput from 'components/common/inputs/SearchInput.vue'
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import InfinityUpdater from 'components/extends/InfinityUpdater.vue'
import AdditionalFieldCard from 'components/additional fields/AdditionalFieldCard.vue'

import AdditionalFieldsApi from '@/api/additionalFieldsApi'
const additionalFields_api = new AdditionalFieldsApi()
import SmarttenderApi from '@/api/smarttenderApi'
const tender_api = new SmarttenderApi()

import { storageMixin } from 'mixins'

export default {
  name: 'AdditionalFieldsPage',
  mixins: [storageMixin],
  data() {
    return {
      activeMenuIndex: 0,
      count: 0,
      additionalFieldItems: [],
      spr: {
        biddingTypes: [],
        classifications: [],
      },
      // Накопительный массив для отложенной загрузки классификаций
      pendingClassificationCodes: new Set(),
      // Флаг для предотвращения множественных запросов
      isLoadingClassifications: false,
      statisticsFilters: {
        //additionalFieldTypes: null, // Тип поля (масив типів (приходить з АПІ)  array   getAdditionalFieldTypes використати
        //biddingTypeIds: null, // Види тендерів (масив int)  array  biddingTypes використати
        //classificationCodes: null, // Категоріїї (масив string) array  treeView  використати
        search: '' // Пошук (string) - шукаємо тільки по назві
      },
      itemFilters: {
        bindingLevel: null, // Тип привʼязки (TENDER,LOT,BID, ......) - NULL або пусто - всі
        binded: null, // Привʼязані до виду тендеру або до категорії (bool?) (BiddingType + Category)
        active: null, // Активні-не активні (bool?)
        pagination: { // Пагінація (сортуємо по ID)
          size: 20,
          page: 1
        },
      },
      loading: {
        items: true,
        statics: false,
      },
      menuTypes: [
        {
          name: this.$t('Purchasing.All'),
          type: 'all',
          count: 0,
          filterTemplate: {
            bindingLevel: null,
            binded: null,
            active: null,},
        },
        {
          name: this.$t('Tenders.ToTender'),
          type: 'toTender',
          class: 'pl-7',
          count: 0,
          filterTemplate: {
            bindingLevel: 'TENDER',
            binded: null,
            active: null,
          },
        },
        {
          name: this.$t('Tenders.ToLot'),
          type: 'toLot',
          class: 'pl-7',
          count: 0,
          filterTemplate: {
            bindingLevel: 'LOT',
            binded: null,
            active: null,
          },
        },
        {
          name: this.$t('AdditionalFields.Tied'),
          type: 'binded',
          class: 'pl-7',
          count: 0,
          filterTemplate: {
            bindingLevel: null,
            binded: true,
            active: null,
          },
        },
        {
          name: this.$t('AdditionalFields.Active'),
          type: 'active',
          class: 'pl-7',
          count: 0,
          filterTemplate: {
            bindingLevel: null,
            binded: null,
            active: true,
          },
        },
        {
          name: this.$t('AdditionalFields.notActive'),
          type: 'notActive',
          class: 'pl-7',
          count: 0,
          filterTemplate: {
            bindingLevel: null,
            binded: null,
            active: false,
          },
        },
      ],
    }
  },
  methods: {
    // Отложенная загрузка классификаций с дебоунсом
    loadClassifications: debounce(function() {
      if (this.pendingClassificationCodes.size === 0 || this.isLoadingClassifications) {
        return
      }

      this.isLoadingClassifications = true
      const codesToLoad = Array.from(this.pendingClassificationCodes)
      this.pendingClassificationCodes.clear()

      tender_api.subcategories(codesToLoad)
        .then(categories => {
          const newClassifications = categories || []
          // Дополнительная проверка на дубли перед добавлением
          const existingCodes = new Set(this.spr.classifications.map(c => c.classificationCode))
          const uniqueNewClassifications = newClassifications.filter(c => !existingCodes.has(c.classificationCode))
          
          this.spr.classifications = [...this.spr.classifications, ...uniqueNewClassifications]
        })
        .catch(() => {
          // В случае ошибки возвращаем коды обратно для повторной попытки
          codesToLoad.forEach(code => this.pendingClassificationCodes.add(code))
        })
        .finally(() => {
          this.isLoadingClassifications = false
        })
    }, 300),

    // Добавление кодов в очередь для загрузки
    addClassificationCodesToQueue(codes) {
      if (!codes || codes.length === 0) {
        return
      }

      const existingCodes = new Set(this.spr.classifications.map(c => c.code))
      const newCodes = codes.filter(code => code && !existingCodes.has(code))
      
      newCodes.forEach(code => this.pendingClassificationCodes.add(code))
      
      if (this.pendingClassificationCodes.size > 0) {
        this.loadClassifications()
      }
    },

    updateField(item) {
      const result = this.$_.cloneDeep(this.additionalFieldItems)
      const index = result.findIndex(el => el.id === item.id)

      if (index !== -1) {
        result[index] = item
        this.$set(this, 'additionalFieldItems', result)
      }
      this.getPageStatistic()
    },
    deleteField(id) {
      this.additionalFieldItems = this.additionalFieldItems.filter(el => el.id != id)
      this.getPageStatistic()
    },
    infinityLoad( ) {
      if (this.count > this.additionalFieldItems.length) {
        const newPage = this.itemFilters.pagination.page + 1
        this.loadPageItems(newPage)
      }
    },
    choseType(type) {
      if (!type) {
        return
      }

      const typeIndex = this.menuTypes.findIndex(i => i.type === type.type)
      if (typeIndex !== -1 && typeIndex !== this.activeMenuIndex) {
        this.$_savePropToDBStorage('additionalFieldPage_new_menuType', type.type)
        this.activeMenuIndex = typeIndex
        this.filterByType = type.filter
        if (type.filterTemplate) {
          Object.entries(type.filterTemplate).forEach(([key, value]) => {
            this.itemFilters[key] = value
          })
        }
        this.count = type.count
        if (this.count === 0) {
          this.additionalFieldItems = []
        } else {
          this.loadPageItems(1)
        }
      }
    },
    getPageStatistic: debounce(function () {
      this.loading.statics = true
      return new Promise((resolve) => {
        additionalFields_api.getAdditionalFieldStatistic(this.statisticsFilters)
          .then(res => {
            Object.entries(res ? res : {}).forEach(([key, value]) => {
              if (key === this.menuTypes[this.activeMenuIndex].type) {
                this.count = value ?? 0
              }
              const menuType = this.menuTypes.find(i => i.type === key)
              if (menuType) {
                menuType.count = value ?? 0
              }
            })
          })
          .finally(() => {
            this.loading.statics = false
            resolve()
          })
      })
    }, 250),
    loadPageItems: debounce(function (page) {
      this.loading.items = true
      this.itemFilters.pagination.page = page

      additionalFields_api.getAdditionalFields({...this.statisticsFilters, ...this.itemFilters})
        .then(res => {
          // Собираем все коды классификаций из новых полей
          let classificationCodes = []
          res?.map(field => field?.bindingCondition?.classificationCodes).forEach((item) => {
            classificationCodes = classificationCodes.concat(item)
          })
          
          // Фильтруем дубликаты и добавляем в очередь для загрузки
          classificationCodes = classificationCodes
            .filter(i => i)
            .filter((code, index, arr) => arr.indexOf(code) === index) // убираем дубли в текущем запросе
          
          this.addClassificationCodesToQueue(classificationCodes)
          if (this.itemFilters.pagination.page === 1) {
            this.additionalFieldItems = res || []
            return
          }
          this.additionalFieldItems = [...this.additionalFieldItems, ...(res || [])]
        })
        .finally(() => {
          this.loading.items = false
        })
    }, 250),
    fullLoading() {
      this.loadPageItems(1)
      this.getPageStatistic()
    },
  },
  computed: {
    canLoad() {
      return this.count >= this.additionalFieldItems.length
    },
  },
  watch: {
    statisticsFilters: {
      deep: true,
      handler() {
        this.fullLoading()
      }
    },
  },
  mounted() {
    if (!this.$can('use', 'availableAdditionalFields')) {
      this.$router.push({ name: 'tenders'})
    }

    let elm = this.$el
    this.itemFilters.pagination.size = Math.floor((elm?.clientHeight || 0) / 150) || 0


    this.$store.dispatch('setBiddingTypes')
      .then(res => this.spr.biddingTypes = res)

    this.$store.dispatch('setAdditionalFieldsTypes')

    this.$_getPropFromDBStorage('additionalFieldPage_new_menuType')
      .then(async (savedType) => {
        const typeItem = this.menuTypes.find(i => i.type === savedType)
        this.choseType(typeItem || this.menuTypes[0])
        this.fullLoading()
      })
  },
  components: {
    NavBar,
    EmptyBlock,
    SearchInput,
    MenuComponent,
    InfinityUpdater,
    AdditionalFieldCard,
  }
}
</script>
